import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import TextField, { type TextFieldProps } from "../TextField";

// TextField with a show/hide toggle. The label stays fixed; aria-pressed carries the state.
function PasswordField({ input, ...props }: Omit<TextFieldProps, "postIcon" | "input"> & { input: Omit<TextFieldProps["input"], "type"> }) {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);
  const id = input.id ?? input.name;
  const Icon = shown ? EyeOff : Eye;
  return (
    <TextField
      {...props}
      input={{ ...input, id, type: shown ? "text" : "password", autoCapitalize: "off", spellCheck: false }}
      postIcon={
        <button
          type="button"
          aria-label={t("ui.auth.fields.showPassword")}
          aria-pressed={shown}
          aria-controls={id}
          onClick={() => setShown((s) => !s)}
          className="-me-1.5 grid size-11 place-items-center rounded-full text-ink-3 transition-[color,background-color,transform] duration-200 hover:bg-accent-soft hover:text-ink active:scale-90"
        >
          <Icon className="size-[22px]" strokeWidth={1.75} aria-hidden />
        </button>
      }
    />
  );
}

export default PasswordField;
